import * as R from 'ramda';
import { CatalogSectionCount } from '../catalog.types';
import { CatalogItem, CatalogItemsLimits } from './product-catalog-es.types';

interface StartEndSectionReduce {
  currentRowIndex: number;
  groupCountsLimits: CatalogItemsLimits[];
}

class CatalogProductsManager {
  static calculateStartEndSectionsIndex(
    sections: CatalogSectionCount[],
    maxItemsPerRow: number,
  ): CatalogItemsLimits[] {
    if (!sections?.length) {
      return [];
    }

    const initialReduceState: StartEndSectionReduce = {
      currentRowIndex: 0,
      groupCountsLimits: [],
    };
    const groupCountsLimits = sections.reduce(
      (a, b) => this.reduceStartEndSectionsIndex(a, b, maxItemsPerRow),
      initialReduceState,
    );
    return groupCountsLimits.groupCountsLimits;
  }

  private static reduceStartEndSectionsIndex(
    previous: StartEndSectionReduce,
    section: CatalogSectionCount,
    maxItemsPerRow: number,
  ) {
    const endRowIndex: number =
      previous.currentRowIndex + Math.ceil(section.itemsCount / maxItemsPerRow) - 1;
    const newGroupCountLimit: CatalogItemsLimits = {
      itemsCount: section.itemsCount,
      sectionId: section.catalogSectionId,
      startRowIndex: previous.currentRowIndex,
      endRowIndex,
    };

    const groupCountsLimits: CatalogItemsLimits[] = [
      ...previous.groupCountsLimits,
      newGroupCountLimit,
    ];

    return {
      currentRowIndex: endRowIndex + 1,
      groupCountsLimits,
    };
  }

  static fillListWithNullItems<T>(
    sectionLimits: CatalogItemsLimits[],
    items: T[],
    maxItemsPerRow: number,
  ): CatalogItem<T>[] {
    if (!sectionLimits.length || !items?.length) {
      return [];
    }

    let newProducts: CatalogItem<T>[] = [...items] as unknown[] as CatalogItem<T>[];

    let indexToInsertFakeProducts = 0;
    for (let index = 0; index < sectionLimits.length; index += 1) {
      indexToInsertFakeProducts += sectionLimits[index].itemsCount;
      const rest = sectionLimits[index].itemsCount % maxItemsPerRow;
      if (rest > 0) {
        const fakeItemsLength = maxItemsPerRow - rest;
        const fakeProducts: CatalogItem<T>[] = Array<CatalogItem<T>>(fakeItemsLength).fill({
          tag: 'null',
        });
        newProducts = R.insertAll(indexToInsertFakeProducts, fakeProducts, newProducts);
        indexToInsertFakeProducts += fakeItemsLength;
      }
    }

    return newProducts;
  }
}

export default CatalogProductsManager;
